import { setJWT } from "../../..//utils//axios";
const initialState = {
  isLoading: false,
  walletAddress: false,
  isWrongNetwork: false,
  error: false,
  success: false,
  isLogged: false,
  user: false,
  email: false,
};
setJWT(localStorage.getItem("jwt_token"));

export const walletReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "WALLET_LOADING":
      return {
        ...state,
        isLoading: true,
        error: false,
        success: false,
      };
    case "WALLET_DATA":
      return {
        ...state,
        isLoading: false,
        walletAddress: payload.walletAddress,
        isWrongNetwork: payload.isWrongNetwork,
        error: false,
      };
    case "WALLET_EMAIL":
      return {
        ...state,
        isLoading: false,
        success: payload.message,
        email: payload.email,
      };
    case "WALLET_REGISTER":
      return {
        ...state,
        isLoading: false,
        success: payload.message,
      };
    case "WALLET_MESSAGE_RESET":
      return {
        ...state,
        success: false,
        error: false,
      };
    case "WALLET_VERIFY":
      setJWT(payload.user.token);
      localStorage.setItem("jwt_token", payload.user.token);
      return {
        ...state,
        isLoading: false,
        isLogged: payload.isLogged,
        user: payload.user,
        success: false,
      };
    case "WALLET_ERROR":
      return {
        ...state,
        isLoading: false,
        success: false,
        error: payload,
      };

    case "DISCONNECT_WALLET":
      return {
        ...state,
        isLoading: false,
        walletAddress: false,
        isWrongNetwork: false,
        error: false,
        success: false,
      };
    case "DISCONNECT":
      localStorage.removeItem("jwt_token");
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
